export default function(number) {
  return !number || typeof number !== 'string'
    ? ''
    : number.slice(0, 3) + ' ' + number.slice(3, 6) + ' ' + number.slice(6);
}
